import { useEffect, useState } from "react";
import api, { fmtErr } from "../../api";
import { toast } from "sonner";

export function QuoteTermsSection() {
  const [lib, setLib] = useState({ standard: [], custom: [] });
  const [dirty, setDirty] = useState(false);
  const load = () => api.get("/quote-terms").then((r) => { setLib(r.data); setDirty(false); }).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const setGroup = (k, list) => { setLib((l) => ({ ...l, [k]: list })); setDirty(true); };
  const move = (k, i, dir) => {
    const list = [...lib[k]];
    const j = i + dir;
    if (j < 0 || j >= list.length) return;
    [list[i], list[j]] = [list[j], list[i]];
    setGroup(k, list);
  };
  const save = async () => {
    try { await api.put("/quote-terms", lib); toast.success("Terms library saved"); load(); }
    catch (e) { toast.error(fmtErr(e)); }
  };

  const group = (title, k, canDelete) => (
    <div data-testid={`terms-${k}`}>
      <p className="text-xs font-bold uppercase tracking-wide text-muted-foreground">{title}</p>
      <p className="mb-1 text-xs text-muted-foreground">
        {k === "standard" ? "Ship with the app — edit wording or turn off; they can't be deleted."
                          : "Your terms — create, edit, reorder, delete. Unticked ones are only suggested."}
      </p>
      {lib[k].map((t, i) => (
        <div key={t.id} className="mb-2 rounded-md border border-border p-2" data-testid={`term-${k}-${t.id}`}>
          <div className="flex items-center gap-2">
            <input type="checkbox" checked={t.default_on !== false} data-testid={`term-${t.id}-default`}
              onChange={(e) => { const list = [...lib[k]]; list[i] = { ...t, default_on: e.target.checked }; setGroup(k, list); }} />
            <span className="flex-1 text-xs font-semibold">{t.suggested ? "Suggested: " : ""}on by default</span>
            <button data-testid={`term-${t.id}-up`} onClick={() => move(k, i, -1)} className="px-1 text-xs font-bold">↑</button>
            <button data-testid={`term-${t.id}-down`} onClick={() => move(k, i, 1)} className="px-1 text-xs font-bold">↓</button>
            {canDelete && <button data-testid={`term-${t.id}-del`} className="px-1 text-xs font-bold text-red-600"
              onClick={() => setGroup(k, lib[k].filter((x) => x.id !== t.id))}>Delete</button>}
          </div>
          <textarea className="field-input mt-1 w-full" rows={2} value={t.text} data-testid={`term-${t.id}-text`}
            onChange={(e) => { const list = [...lib[k]]; list[i] = { ...t, text: e.target.value }; setGroup(k, list); }} />
          <label className="mt-1 flex items-center gap-2 text-xs font-semibold">Applies to
            <select className="field-input w-auto" value={t.applies_to || "both"} data-testid={`term-${t.id}-applies`}
              onChange={(e) => { const list = [...lib[k]]; list[i] = { ...t, applies_to: e.target.value }; setGroup(k, list); }}>
              <option value="both">both quote types</option>
              <option value="seasonal">seasonal only</option>
              <option value="one_time">one-time only</option>
            </select></label>
        </div>
      ))}
      {canDelete && (
        <button data-testid="add-custom-term" className="text-xs font-bold text-primary"
          onClick={() => setGroup("custom", [...lib.custom, { text: "", default_on: false, suggested: false, applies_to: "both" }])}>
          + Add custom term
        </button>
      )}
    </div>
  );

  return (
    <section className="card-flat space-y-3 p-5" data-testid="quote-terms-section">
      <p className="label-caps">Quote terms</p>
      <p className="text-xs text-muted-foreground">Merge fields like {"{business_name}"} and {"{extra_visit_rates}"} are filled in when a quote is created.</p>
      {group("Standard terms", "standard", false)}
      {group("Custom terms", "custom", true)}
      {dirty && (
        <button data-testid="terms-save" onClick={save}
          className="h-10 w-full rounded-md bg-primary text-sm font-bold text-primary-foreground">Save terms library</button>
      )}
    </section>
  );
}
